module.exports = __webpack_public_path__ + "static/img/homeProduct.0c7bc82f.png";